import { connect } from 'react-redux';

import { setActivePack, toggle } from '~/Redux/Modules/StickerPacksUi';

import { getStickerPacks } from '~/Redux/Modules/Products';

import { STICKER_PACKS } from '~/Config/Products';

import Stickers from '~/Components/Global/Stickers/Stickers';

const mapStateToProps = ({ Products, StickerPacksUi }) => {
  return {
    packs: Products[STICKER_PACKS],
    tabOpen: StickerPacksUi.tabOpen,
    activePack: StickerPacksUi.activePack,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getStickerPacks: () => dispatch(getStickerPacks()),
    setActivePack: id => dispatch(setActivePack(id)),
    toggleStickers: value => dispatch(toggle(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Stickers);
